export default __webpack_public_path__ + "static/media/login_bakground_light.cc891b3c.jpg";